export const en = {
    'common-error-update-regions': 'Error updating display regions',
    'link-message-groups': 'View'
};
